export const PHARMACY_ORDERS_PRESCRIPTION = 1;
export const PHARMACY_ORDERS_DISCOUNT = 2;
export const PHARMACY_ORDERS_DELIVERY_DETAILS = 3;
export const PHARMACY_WATSON_ORDERS_RX = 1;
export const PHARMACY_WATSON_ORDERS_DELIVERY_DETAILS = 2;
export const PHARMACY_WATSON_ORDERS_CALL = 3;

export const PHARMACY_ORDERS_STEP = [
  {val: PHARMACY_ORDERS_PRESCRIPTION, label: 'Orders'},
  {val: PHARMACY_ORDERS_PRESCRIPTION, label: 'Discount'},
  {val: PHARMACY_ORDERS_DELIVERY_DETAILS, label: 'Delivery'}
]

export const PHARMACY_WATSON_ORDER_STEP = [
  {val: PHARMACY_WATSON_ORDERS_RX, label: 'Rx'},
  {val: PHARMACY_WATSON_ORDERS_DELIVERY_DETAILS, label: 'Delivery Details'},
  {val: PHARMACY_WATSON_ORDERS_CALL, label: 'Call'}
]

export const PRESCRIPTION_PAGE = 1;
export const DETAILS_PAGE = 2;
export const VERIFICATION_PAGE = 3;
export const FINISHED_PAGE = 4;

export const BRANCH_PICKUP_PAGES = [
  {val: DETAILS_PAGE, label: 'Your Details'},
  {val: VERIFICATION_PAGE, label: 'Verification'},
  {val: FINISHED_PAGE, label: 'Pick-Up'},
];

export const DELIVERY_PAGES = [
  {val: PRESCRIPTION_PAGE, label: 'Rx'},
  {val: DETAILS_PAGE, label: 'Delivery Details'},
  {val: FINISHED_PAGE, label: 'Call'},
];
